module.exports = __webpack_public_path__ + "img/card-assuntos-corporativos.c70f9285.svg";